<template>
  <h1 class="mt-10">Login</h1>
  <form name="login" @submit.prevent="signIn">
    <div class="form-row">
      <div class="col-8 col-md-4 col-lg-3 col-xl-2">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="email">E-Mail</label>
          </div>
          <input v-model="form.email" class="form-control form-control-lg" id="email" placeholder="" required>
        </div>
      </div>
      <div class="col-8 col-md-4 col-lg-3 col-xl-2">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="password">Passwort</label>
          </div>
          <input v-model="form.password" class="form-control form-control-lg" id="password" type="password"
                 placeholder="">
        </div>
      </div>
      <div v-if="form.err" class="col-8">
        <div class="alert alert-danger" role="alert">
          {{ form.err }}
        </div>
      </div>
      <div class="col-8 text-center">
        <button type="submit" class="mb-4">Login</button>
        <a href="#" @click="resetPassword">Neues Passwort setzen</a>
        <input v-model="form.resetPassword" id="resetPassword" type="hidden"/>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "SignIn",
  data() {
    return {
      form: {
        email: '',
        password: '',
        err: '',
        resetPassword: '0'
      }
    }
  },
  methods: {
    async signIn() {
      this.form.err = null
      const response = await this.$store.dispatch('signIn', {...this.form})

      if (response.success) this.$router.push('/')
      else if (response.err) this.form.err = response.err

      this.form.resetPassword = '0'
    },
    resetPassword() {
      this.form.resetPassword = '1'
      this.signIn()
    }
  }
}
</script>

<style scoped>

</style>